import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoCoreModule } from '@core/transloco/transloco.module';
import { MatIconModule } from '@angular/material/icon';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
import { FuseScrollbarModule } from '@fuse/directives/scrollbar';
import { FuseScrollResetModule } from '@fuse/directives/scroll-reset';
import { FuseAlertModule } from '@fuse/components/alert';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatTabsModule } from '@angular/material/tabs';
import { RequiredRolesModule } from '@targx/directives/required-roles/required-roles.module';
import { SelectedCreatedByComponent } from './components/selected-created-by/selected-created-by.component';
import { DialogSelectOfferComponent } from './components/dialogs/dialog-select-offer/dialog-select-offer.component';
import { DialogAddShippingComponent } from './components/dialogs/dialog-add-shipping/dialog-add-shipping.component';
import { DialogAddCostComponent } from './components/dialogs/dialog-add-cost/dialog-add-cost.component';
import { DialogSalesTargetComponent } from './components/dialogs/dialog-sales-target/dialog-sales-target.component';
import { DialogSendProposalComponent } from './components/dialogs/dialog-send-proposal/dialog-send-proposal.component';
import { FreightOptionsTableComponent } from './components/freight-options-table/freight-options-table.component';
import { SearchableSelectComponent } from './components/searchable-select/searchable-select.component';
import { FreightDestinationFilterComponent } from './components/freight-destination-filter/freight-destination-filter.component';
import { CalculationTracePanelComponent } from './components/calculation-trace-panel/calculation-trace-panel.component';
import { OfferTotalsSummaryComponent } from './components/offer-totals-summary/offer-totals-summary.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoCoreModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatLuxonDateModule,
    MatMenuModule,
    MatProgressBarModule,
    MatIconModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatTooltipModule,
    MatSlideToggleModule,
    FuseScrollbarModule,
    FuseScrollResetModule,
    FuseAlertModule,
    MatPaginatorModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatTabsModule,
    RequiredRolesModule,
  ],
  exports: [
    CalculationTracePanelComponent,
    OfferTotalsSummaryComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoCoreModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatLuxonDateModule,
    MatMenuModule,
    MatProgressBarModule,
    MatIconModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatTableModule,
    MatTooltipModule,
    MatSlideToggleModule,
    FuseScrollbarModule,
    FuseScrollResetModule,
    FuseAlertModule,
    MatPaginatorModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatTabsModule,
    RequiredRolesModule,
    SelectedCreatedByComponent,
    FreightOptionsTableComponent,
    FreightDestinationFilterComponent,
    SearchableSelectComponent,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'D',
        },
        display: {
          dateInput: 'DDD',
          monthYearLabel: 'LLL yyyy',
          dateA11yLabel: 'DD',
          monthYearA11yLabel: 'LLLL yyyy',
        },
      },
    },
  ],
  declarations: [
    CalculationTracePanelComponent,
    OfferTotalsSummaryComponent,
    SelectedCreatedByComponent,
    DialogSelectOfferComponent,
    DialogAddShippingComponent,
    DialogAddCostComponent,
    DialogSalesTargetComponent,
    DialogSendProposalComponent,
    FreightOptionsTableComponent,
    FreightDestinationFilterComponent,
    SearchableSelectComponent,
  ],
})
export class SharedModule {}
